
import { useLanguage } from '@afsa/shared'
import { type WebPageSection } from '@/lib/api'
import { motion } from 'framer-motion'
import { fadeUp, viewportReveal } from '@/lib/motion'
import { parseHtmlString } from '@/utils/helpers/html'
import Heading from '@/components/ui/Typography/Heading'

interface WhoAreWeProps {
  className?: string
  data: WebPageSection
}

const WhoAreWe = ({ className, data }: WhoAreWeProps) => {
  const { t } = useLanguage()

  return (
    <section className={`md:py-16 bg-white ${className}`} aria-labelledby="who-are-we-title">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative w-full border-b-2 border-gray-200 mb-8">
          <h2
            id="who-are-we-title"
            className="text-sm font-medium font-satoshi text-gray-600 tracking-wide uppercase border-b-2 border-wine-100 inline-block pb-2"
          >
            {t('who_are_we_title')}
          </h2>
        </div>

<div className="flex flex-col lg:grid lg:grid-cols-[7fr_5fr] gap-2 md:gap-8 items-stretch">
  
  {/* IMAGE SIDE */}
  <motion.div
    className="self-stretch min-h-0"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={viewportReveal}
  >
    <div className="w-full h-full">
      <img
        src={data.fileUrl ?? ""}
        alt={data.title ?? ""}
        className="w-full h-full object-cover aspect-video"
      />
    </div>
  </motion.div>

  {/* TEXT SIDE */}
  <motion.div
    className="self-stretch min-h-0"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={viewportReveal}
  >
    <div className="bg-wine-100 p-4  md:p-8 xl:p-10 text-white h-full gap-4 lg:gap-6 flex flex-col justify-center">
      <Heading level={3} className="text-white">
        {data.title}
      </Heading>

      {data.description && (
        <div dangerouslySetInnerHTML={parseHtmlString(data.description)} />
      )}
    </div>
  </motion.div>

</div>


      </div>
    </section>
  )
}

export default WhoAreWe